export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_10.6bd2432b.jpg";